import React from 'react';
import './Input.css';

const Input = ({
  type = 'text',
  label,
  placeholder,
  value,
  onChange,
  error,
  disabled = false,
  readOnly = false,
  icon,
  suffix,
  hint,
  className = '',
  ...props
}) => {
  return (
    <div className={`input-wrapper ${error ? 'input-error' : ''} ${disabled ? 'input-disabled' : ''} ${className}`}>
      {label && <label className="input-label">{label}</label>}
      <div className="input-container">
        {icon && <span className="input-icon">{icon}</span>}
        <input
          type={type}
          className="input-field"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          readOnly={readOnly}
          {...props}
        />
        {suffix && <span className="input-suffix">{suffix}</span>}
      </div>
      {error && <span className="input-error-text">{error}</span>}
      {hint && !error && <span className="input-hint">{hint}</span>}
    </div>
  );
};

export const TextArea = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  disabled = false,
  rows = 4,
  className = '',
  ...props
}) => {
  return (
    <div className={`input-wrapper ${error ? 'input-error' : ''} ${disabled ? 'input-disabled' : ''} ${className}`}>
      {label && <label className="input-label">{label}</label>}
      <textarea
        className="input-field input-textarea"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        rows={rows}
        {...props}
      />
      {error && <span className="input-error-text">{error}</span>}
    </div>
  );
};

export default Input;
